/* cn */
module.exports = {
    obj: {
        "broswer1": "赛方提醒您：您的浏览器目前会导致竞赛网页卡顿，推荐使用Google Chrome浏览器进行竞赛，点击下载谷歌浏览器。",
        "broswer2": "Win32位 ",
        "broswer3": "Win64位 ",
        "broswer4": "Mac",
        "title99": "若您中途退出关卡，当前关卡数据将会自动保存，下次登录平台仍可从当前关卡继续。",
        "nav_language": "语言切换",
        "signup_button": "注册",
        "homepage_button1": "登 录",
        "homepage_button2": "注 册",
        "signup_title": "创建账号",
        "signin_title": "登录",
        "myaccount_button": "保存",
        "signup_email4": "如果您一小时内未收到邮件 ，请重新提交注册信息！\n\n如您在收件箱中未查收到验证邮件，\n请检查一下垃圾箱，感谢您的配合！",
        "signup_email2": "激活邮件已发送至您的邮箱，请前往邮箱激活账号，完成注册最后一步。",
        "signup_email3": "返回登录页",
        "signup_email1": "激活邮箱账号",
        "signin_note3": "请输入您的密码",
        "signin_note2": "无效的邮箱账号",
        "signin_note1": "请输入您的邮箱账号",
        "signin_note5": "未注册的账号",
        "signin_note4": "密码错误",
        "forPass_title": "忘记密码",
        "failWin_txt2": "能量耗尽，重新再来一次吧！",
        "signup_fail1": "验证码失效",
        "unit8_name": "站住，别跑！",
        "signup_fail2": "邮箱已注册",
        "competition_button": "开始挑战",
        "failWin_txt1": "步数出错，重新再来一次吧！",
        "failWin_txt3": "红色能量不能吃，重新再来一次吧！",
        "unit3_name": "我爱飞板",
        "sucPass_title": "重置成功",
        "bindaccountMsg": "账号已绑定手机，无法二次绑定",
        "bindaccountMsgs": "账号已过期",
        "bindaccountWarn": "绑定你的手机号后激活",
        "bindaccountWarn1": "绑定失败，该手机号绑定其他账号",
        "signup_note5": "验证码错误",
        "signup_note4": "无效的手机号",
        "signup_note7": "请输入您的姓",
        "signup_note6": "无效的邮箱账号",
        "signup_note1": "不存在的学校代码",
        "signup_note3": "密码须一致",
        "signup_note2": "密码须为8-16位字母与数字组合",
        "signup_note9": "请选择......",
        "signup_note8": "请输入您的名",
        "forPass_txt1": "通过手机号或邮箱账号验证来重置密码",
        "forPass_txt3": "验证",
        "forPass_txt2": "邮箱",
        "verifySuc_button": "进入竞赛页",
        "signin_button": "登录",
        "unit7_name": "困难重重",
        "verifyFail_txt": "邮件验证已完成，该验证链接已失效。\n\n\n如遇问题请联系我们info@codingolympics.cn",
        "signup_txt8": "请再次输入密码",
        "signup_txt9": "手机号",
        "unit9_name": "能量危机",
        "signup_txt1": "姓",
        "signup_txt2": "名",
        "signup_txt3": "年级",
        "signup_txt4": "学校代码",
        "signup_txt5": "请向老师询问学校代码",
        "signup_txt6": "密码",
        "signup_txt7": "密码须为8-16位字母与数字组合",
        "failWin_txt": "好像不太对，重新再来一次吧！",
        "verifyFail_title": "无效的链接",
        "verifyWrongemail_txt": "网址错误，请确保当前的验证链接与邮箱收到的链接保持一致。\n\n如遇问题请联系我们info@codingolympics.cn",
        "unit6_name": "数学规则",
        "failWin_title": "重试",
        "unit5_name": "追踪侦探",
        "competition_note": "报名成功！竞赛将在五月一日正式开始。有兴趣学编程吗?请前往我们的编程资源网址：<a target='view_window' href='https://www.codingolympics.cn/codeResources'>https://www.codingolympics.cn/codeResources</a>",
        "signup_txt12": "账号",
        "signup_txt13": "请输入您的账号",
        "signup_txt10": "手机验证码",
        "signup_txt11": "发送验证码",
        "myaccount_txt1": "姓",
        "myaccount_txt2": "名",
        "myaccount_txt3": "年级",
        "signin_txt4": "注册",
        "signin_txt2": "设置密码",
        "signin_txt3": "忘记密码",
        "signin_txt1": "手机号",
        "signin_txt11": "账号/手机号",
        "sucWin_title": "挑战成功",
        "competition_title": "竞赛实时排行",
        "unit2_name": "飞船帮手",
        "homepage_title": "加入竞赛",
        "setPass_title": "设置密码",
        "resetWin_title": "重置",
        "myaccount_title": "我的账号",
        "emailVerify_txt2": "如遇问题请联系我们info@codingolympics.cn",
        "emailVerify_txt1": "抱歉，这个验证链接已失效，点击下方按钮重新验证您的邮箱。",
        "language_switch5": "阿拉伯语",
        "language_switch4": "希伯来语",
        "language_switch3": "西班牙语",
        "language_switch2": "英语",
        "language_switch1": "简体中文",
        "signup_note15": "请输入验证码",
        "signup_note14": "请输入您的手机号",
        "signup_note17": "请填写上述所有信息",
        "signup_note16": "请输入您的邮箱账号",
        "signup_note11": "请向老师询问学校代码",
        "signup_note10": "请选择您的年级",
        "signup_note13": "请再次输入密码",
        "signup_note12": "请输入您的密码",
        "resetWin_txt": "确定吗？这会删除所写代码并恢复原状、",
        "emailVerify_title": "无效的链接",
        "forPass_win": "重置密码链接已发送至您的邮箱，请查收",
        "nav_setting": "设置",
        "setPass_txt2": "密码须为8-16位字母与数字组合",
        "setPass_txt3": "请重新输入密码",
        "setPass_txt1": "密码",
        "setPass_txt4": "提交",
        "nav_name": "国际青少年奥林匹克编程竞赛",
        "emailVerify_button": "再次发送验证邮件",
        "emailVerify_note": "*验证邮件已成功发送至您的邮箱!",
        "competition_txt1": "排名",
        "competition_txt2": "学校",
        "competition_txt22": "学生",
        "verifyWrongemail_title": "错误的网址",
        "competition_txt4": "我的关卡",
        "competition_txt44": "我的星数",
        "competition_txt5": "学校分数",
        "competition_txt6": "学校排名",
        "verifyWrong_title": "错误的网址",
        "unit4_name": "智能循环",
        "competition_txt3": "总成绩",
        "forPass_note2": "无效的账号",
        "forPass_note3": "请输入您的密码",
        "forPass_note1": "请输入您的邮箱账号",
        "forPass_note6": "请输入您的密码",
        "forPass_note7": "该账号未注册",
        "forPass_note4": "请再次输入密码",
        "forPass_note5": "密码须一致",
        "sucWin_txt": "恭喜你，通过本关挑战",
        "setting_1": "我的账号",
        "setting_2": "退出账号",
        "verifyWrong_txt": "网址错误，请确保当前的验证链接与邮箱收到的链接保持一致。\n\n如遇问题请联系我们info@codingolympics.cn",
        "verifySuc_txt1": "恭喜您已成功创建账号，参赛准备已就绪！",
        "sucPass_button": "返回首页",
        "myaccount_txt4": "学校",
        "verifySuc_title": "注册成功！",
        "myaccount_txt5": "邮箱",
        "signup_win2": "注册需要填写学校代码，并且使用有效邮箱验证账号，如你没有学校代码，请邀请你所在班级的老师通过邮箱联系我们：info@codingolympics.cn",
        "signup_win1": "注册前请须知...",
        "unit10_name": "远程协助",
        "unit1_name": "初探火星",
        "bad_network": "未能连接到网络",
        "competition_txt7": "最高分数",
        "competition_txt8": '国家',
        "grade1": '一年级',
        "grade2": '二年级',
        "grade3": '三年级',
        "grade4": '四年级',
        "grade5": '五年级',
        "grade6": '六年级',
        "grade7": '七年级',
        "grade8": '八年级',
        "grade9": '九年级',
        "grade10": '十年级',
        "grade11": '十一年级',
        "grade12": '十二年级',
        "competition_nav": '你好',
        "timeout01": '登录过期',
        "timeout02": '您的账号在其他地方登录了，请重新登录',
        "timeout03": '确 定',
        "timeout04": '取 消',
        "schoolName": '学校/机构名字',
        "signin_note50": "比赛将于2020年2月15号正式开启，敬请期待！",
        "myaccountUpdata_title": "修改账号信息",
        "myaccountUpdata_title01": "欢迎参加第二届ICode国际青少年编程竞赛初赛！为了给您带来更好的比赛体验，请确认您的账户信息是否需要更新。一旦确认，就不能再修改了哦！如有疑问，可咨询ICode老师：13162336268",
        "badMsg": "用户基本信息有效-无法二次更新",
        "errmsg": "比赛将于2020年2月15号正式开启，敬请期待！",
        "score1": "学生分数排行榜",
        "score2": "学校总分排行榜",
        "score3": "全球",
        "score4": "校内",
        "levelProgress1": "初级组",
        "levelProgress2": "高级组",
        "levelProgress3": "中级组",
        "version": "我的级别",
        "begin": "入门组",
        "modeCode": "Python关卡",
        "modeScratch": "积木关卡",
        "allStars": "获得的星星总数",
        "allSteps": "精简的移动步数",
        "allLines": "精简代码的行数",
        "bad_errorMsg1": "只能修改为下拉列表中已认证的学校。",
        "bad_errorMsg2": "已加入被认证的学校，不能修改哦",
        "levelProgressAll": '总成绩',
        "levelProgressToday": "今日最佳",
        "notice_lang1": "学习平台全新改版升级！<br/>现在，你已经成为了一名宇航员，可以用代码帮助Dev在太空中历险。从地球出发，随着编程水平的提升，你可以飞向火星、木星甚至更远。赶快开始你的编程之旅吧！",
        "notice_lang2": "新学期已经开始，在忙碌学习的同时，要记得常来和Dev玩耍哦！如果你有什么好的想法和建议，都可以写邮件告诉我们，我们的邮箱是：info@icode.org.cn，期待你的来信！",
        "notice_lang3": "如果你意犹未尽，可以成为正式宇航员，开启额外的练习关卡。<br/>成为正式宇航员并通过上一级的月赛后，你也将获得火星、木星和土星月赛的参赛资格。",
        "notice_lang4": "地球级月赛全新升级为每周一次的晋级赛！<br/>你可以随时参加比赛，只要90分钟内获得60颗星，即可立即升级火星航行执照！没有通过也不要紧，每周一0点晋级赛将自动更新，你将再次获得挑战的机会！",
        "notice_lang5": "两大全新功能上线！</br><span style='color:#ffec44'>随机关卡：</span>在保证公平的情况下，每位选手可能开启不同的关卡地图。</br><span style='color:#ffec44'>每日最佳榜：</span>实时更新每天得分最多的学校。",

        "notice_gd1": "欢迎参加2021年编创未来挑战赛，预选赛将在2021年10月8日开启，祝大家赛出好成绩！",

        "notice_wx1": "欢迎参加青少年编程挑战赛，决赛时间如下：<br/><br/>初级组&高级组：<b style='color:#ffef6b'>2020年12月6日 9:00-10:00</b><br/>中级组：<b style='color:#ffef6b'>2020年12月6日 10:30-11:30</b><br/><br/>请各位选手提前30分钟签到准备，祝大家赛出好成绩！",
        "notice_glb": "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;第三届ICode全球青少年编程竞赛（中国区）预选赛开始啦！<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;预选赛阶段将持续三个月(3月1日-5月31日)，随时报名，随时参赛。无需编程基础也可参赛，在比赛中GET编程知识！<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;优胜者将有机会参加全球决赛，与世界各地的高手同台竞技！",
        "notice_wx_30": "本届大赛线上初赛阶段，分散在各学校进行，初赛将于5月上旬结束，请大家合理安排好时间。<br><br>决赛分配名额，将根据线上初赛的有效人数进行分配计算。决赛举行时间5月下旬线下举行。",

        "myCompetitions": "我的比赛",
        "competitionName": "比赛名称",
        "competitionProgress": "比赛进度",
        "notStart": "比赛未开始",
        "ongoing": "比赛中",
        "gameover": "比赛结束",
        "registrationReview": "报名审核中",
        "registrationFailed": "报名失败",
        "registrationSpproved": "报名成功",
        "notParticipated": "未参赛",
        "participated": "已参赛",
        "myAwards": "我的成绩",
        "remarks": "备注",
        "downloadCard": "下载准考证",
        "download": "其他信息",
        "noData": "暂无比赛数据",
        "registrateFinal": "决赛报名",
        "myProgress": "我的进度",
        "myHome": "我的首页",
        "divisions": "组别",
        "stepTips": '月赛将于6月28日开启',
        "index_txt49_noOpen": "该比赛仅向正式宇航员开放",
        'finalsTxt': "现在不是比赛时间，不能进入",
        "finalsTxt_noOpen": "你不是决赛选手，不能加入比赛",
        "myStars": "我的星星",
        "MyScore": "我的成绩",
        "Leaderboard": "我的排行榜",
        'langTitle': "恭喜您，当您成功登录后，你已经成为了ICode编程宇宙中的【见习宇航员】。作为【见习宇航员】，您可以免费使用所有的基础学习和竞赛功能，享受学习编程的快乐！<br/>您也可以赞助我们，成为【正式宇航员】，开启额外的学习内容和竞赛内容：",
        'langTitle1': "您的赞助可以帮助我们持续地提供优质的学习内容和服务，ICode愿和您一起成长！",
        'pay_txt1': '成为正式宇航员',
        'pay_txt2': '赞助ICode',
        'pay_txt3': '请使用微信扫码支付',
        'pay_txt4': '1个月',
        'pay_txt5': '3个月',
        'pay_txt6': '12个月',
        'index_txt1': "通过地球月赛，可以升级为火星航行执照",
        'index_txt2': "通过火星月赛，可以升级为木星航行执照",
        'index_txt3': "通过木星月赛，可以升级为土星航行执照",
        'index_txt4': "你已拥有了最高级的航行执照",
        'index_txt5': "地球航行执照",
        'index_txt6': "火星航行执照",
        'index_txt7': "木星航行执照",
        'index_txt8': "土星航行执照",
        'index_txt9': "见习宇航员",
        'index_txt10': "正式宇航员",
        'index_txt11': "成为正式宇航员",
        'index_txt12': "欢迎您，正式宇航员",
        'index_txt13': "Python星球",
        'index_txt14': "积木星球",
        "index_txt15": "训练场",
        "index_txt16": "欢迎来到地球训练场",
        "index_txt17": "欢迎来到火星训练场",
        "index_txt18": "欢迎来到木星训练场",
        "index_txt19": "欢迎来到土星训练场",
        "index_txt20": "开始训练",
        "index_txt210": "下次晋级赛刷新时间：",
        "index_txt211": "下次月赛时间：2020年10月31日 19:00-20:30",
        "index_txt212": "下次月赛时间：2020年11月28日 19:00-20:30",
        "index_txt213": "",
        'index_txt22': "进入月赛",
        'jsNotice': "2020年ICode中国区决赛将于8月8日-8月9日在上海举办。参赛选手进入考场并连接考场wifi后，方可加入比赛。如有问题请咨询监考老师。祝大家比赛顺利，发挥出自己的最好水平！",
        'jsNoticeDemo': "模拟赛将开启三场：2020年8月1日9:30/14:30/19:00。<br/>每场90分钟，仅限中国区决赛选手参加。<br/>模拟赛题目难度不作为决赛难度参考。<br/>模拟赛仅供熟悉流程，不评选任何奖项。",
        'finals_txt1': '2020 ICODE中国区决赛',
        'finals_txt2': '模拟决赛',
        "finals_txt3": '2020 ICODE中国区决赛(模拟)',

        'index_txt34': '持有火星航行执照即可进入',
        'index_txt35': '持有木星航行执照即可进入',
        'index_txt36': '持有土星航行执照即可进入',
        'index_txt37': '成为正式宇航员即可开启',
        'index_txt38': '2020年6月地球赛(Python)',
        'index_txt39': '2020年6月地球赛(积木)',
        'index_txt40': '2020年7月地球赛(Python)',
        'index_txt41': '2020年7月地球赛(积木)',
        'index_txt42': '2020年7月火星赛(Python)',
        'index_txt43': '2020年7月火星赛(积木)',
        'index_txt44': '2020年8月地球赛(Python)',
        'index_txt45': '2020年8月地球赛(积木)',
        'index_txt46': '2020年8月火星赛(Python)',
        'index_txt47': '2020年8月火星赛(积木)',
        'index_txt470': '2020年8月木星赛(Python)',
        'index_txt471': '2020年8月木星赛(积木)',
        'index_txt472': '2020年9月地球赛(Python)',
        'index_txt473': '2020年9月地球赛(积木)',
        'index_txt474': '2020年9月火星赛(Python)',
        'index_txt475': '2020年9月火星赛(积木)',
        'index_txt476': '2020年9月木星赛(Python)',
        'index_txt477': '2020年9月木星赛(积木)',
        'index_txt478': '2020年9月土星赛(Python)',
        'index_txt479': '2020年9月土星赛(积木)',

        'index_txtA1': '地球积木周赛',
        'index_txtA2': '地球Python周赛',


        'index_txt48': '关卡创作',
        'index_txt49': '月赛尚未开始',
        'index_txt50': '月赛将在每个月的最后一个周六晚上19:00-20:30开启。<br/>第一次月赛将开始于2020年6月27日19:00，敬请期待。',
        'index_txt51': "全国比赛",
        'index_txt52': "月赛",
        'index_txt53': "地球级",
        'index_txt54': "火星级",
        'index_txt55': "木星级",
        'index_txt56': "土星级",

        "star_txt1": '模式选择',
        "star_txt2": '班级管理',
        "star_txt3": '课程选择',
        "star_txt4": '关卡选择',
        "star_txt5": '设为当前课程',
        "star_txt6": '姓名',
        "star_txt7": '班级管理',
        "star_txt8": '我的班级',
        "star_txt9": '课程星数',
        "star_txt10": '关',
        'star_txt11': "你的账号已失效，请填写可用的手机号码进行恢复",

        'index_course_100120': "基础训练(2)",
        'index_course_100130': "基础训练(3)",
        'index_course_100140': "基础训练(4)",
        'index_course_10010': "基础训练(1)",
        'index_course_10012': "基础训练(2)",
        'index_course_10013': "基础训练(3)",
        'index_course_10014': "基础训练(4)",
        'index_course_1001': "基础训练(1)",
        'index_course_1002': "选手创作关卡",
        'index_course_1003': "for循环练习",
        'index_course_1004': "变量练习",
        'index_course_1005': "递归入门",
        'index_course_1006': "条件语句练习",
        'index_course_1007': "重复执行练习",
        'index_course_1008': "变量练习",
        'index_course_1009': "range函数",
        'index_course_1010': "距离判断",
        'index_course_1011': "重复中的变量(1)",
        'index_course_1012': "复杂的变量",
        'index_course_1013': "if else",
        'index_course_1014': "elif语句",
        'index_course_1015': "识别循环规律",
        'index_course_1016': "识别重复规律",
        'index_course_1017': "复杂嵌套循环",
        'index_course_1018': "复杂嵌套重复",
        'index_course_1019': "条件积木练习",
        'index_course_1020': "while语句入门",
        'index_course_1021': "绿色飞板",
        'index_course_1022': "函数入门",
        'index_course_1023': "选手创作关卡",
        'index_course_1024': "多重递归",
        'index_course_1025': "飞板入门",
        'index_course_1026': "多次递归",
        'index_course_1027': "绿色能量",
        'index_course_1028': "太阳能板",
        'index_course_1029': "太阳能板",
        'index_course_1030': "多分支条件",
        'index_course_1031': "新手引导",
        'index_course_1032': "基本操作",
        'index_course_1033': "变化的循环",
        'index_course_1034': "简单嵌套循环",
        'index_course_1035': "使用多个变量",
        'index_course_1036': "遍历飞板",
        'index_course_1037': "遍历物品",
        'index_course_1038': "逻辑运算",
        'index_course_1039': "飞板组合运动",
        'index_course_1040': "带参数的函数",
        'index_course_1041': "两次递归",
        'index_course_1042': "遍历字典",
        'index_course_1043': "多参数函数",
        'index_course_1044': "新手引导",
        'index_course_1045': "选手创作关卡",
        'index_course_1046': "基本操作",
        'index_course_1047': "简单嵌套重复",
        'index_course_1048': "使用多个变量",
        'index_course_1049': "逻辑运算",
        'index_course_1050': "坐标入门",
        'index_course_1051': 'for循环入门(1)',
        'index_course_1052': 'for循环入门(2)',
        'index_course_1053': '重复执行入门(1)',
        'index_course_1054': '重复执行入门(2)',
        'index_course_1055': '变量入门',
        'index_course_1056': '条件语句入门',
        'index_course_1057': '条件积木入门',
        'index_course_1058': '变量入门',
        'index_course_1059': '嵌套重复',
        'index_course_1060': '暂未开放',
        'index_course_1061': '暂未开放',
        'index_course_1062': '暂未开放',
        'index_course_1063': '暂未开放',
        'index_course_1064': '暂未开放',
        'index_course_1065': '暂未开放',
        'index_course_1066': '暂未开放',
        'index_course_1067': '暂未开放',
        'index_course_1068': '暂未开放',
        'index_course_1069': '暂未开放',
        'index_course_1070': '暂未开放',
        "earth_bulletin": "月赛将在每个月的最后一个周六晚上19:00-20:30开启。<br/>9月月赛将开始于2020年9月26日19:00，敬请期待。",
        "mars_bulletin": "月赛将在每个月的最后一个周六晚上19:00-20:30向正式宇航员开启。</br/>9月月赛将开始于2020年9月26日19:00，敬请期待。",
        "saturn_bulletin": "",
        "jupiter_bulletin": "",
        "race_unannounced": "未公布",
        'race_noaward': "未获奖",
        "gameId_msg_701": "第二届国际青少年编程竞赛（中国区）决赛",
        "gameId_msg_702": "第二届国际青少年编程竞赛（中国区）决赛",
        "gameId_msg_703": "第二届国际青少年编程竞赛（中国区）决赛",
        "gameId_msg_704": "第二届国际青少年编程竞赛（中国区）决赛",
        "gameId_msg_801": "第二届国际青少年编程竞赛（中国区）模拟赛",
        "gameId_msg_802": "第二届国际青少年编程竞赛（中国区）模拟赛",
        "gameId_msg_803": "第二届国际青少年编程竞赛（中国区）模拟赛",
        "gameId_msg_804": "第二届国际青少年编程竞赛（中国区）模拟赛",
        "gameId_msg_1": "第一届国际青少年编程竞赛全球初赛",
        "gameId_msg_2": "奥林匹克编程闯关平台",
        "gameId_msg_3": "以色列奥林匹克编程大赛",
        "gameId_msg_4": "第二届国际青少年编程竞赛（中国区）初赛",
        "gameId_msg_5": "第一届国际青少年编程竞赛（中国区）决赛",
        "gameId_msg_6": "ICode学习平台",
        "prizeId_1": "金奖",
        "prizeId_2": "银奖",
        "prizeId_3": "铜奖",
        "prizeId_4": "参与奖",
        "prizeId_5": "奇思妙想奖",
        "prizeId_6": "小小演说家",
        "prizeId_7": "最具潜质奖",
        "prizeId_8": "小小黑客奖",
        "prizeId_9": "女生创意奖",
        "prizeId_10": "男生创意奖",
        "prizeId_11": "编程小能手",
        "prizeId_12": "最美推广大使",
        "prizeId_13": "天马行空奖",
        "prizeId_14": "“小试牛刀”奖",
        "prizeId_15": "“崭露头角”奖",
        "prizeId_16": "明日之星",
        "prizeId_18": "晋级证书",
        "time_finals": "距离比赛开始：",
        "time_finals01": "比赛已结束",
        "non-finalist": "未参加",
        "no_data_course_txt_0": "你已经完成了积木星球所有训练",
        "no_data_course_txt_1": "到Python星球去接受更多的挑战吧",
        "enter_tech_btn": "进入考核",
        "ret_coe_txt_49": "课程未开放",
        "course_explain": "操作说明",
        "invite_title": "会员邀请",
        "week_game_tips": "本周晋级赛已开放，赶快参加吧！",
        "week_game_tips_info": "每周只有一次机会参加晋级赛<br/> 开始后必须在90分钟内完成<br/> 确定现在开始？",
        "week_game_tips_info_txt": "确定开始",

        "game_title_8001": "ICode地球级积木晋级赛",
        "game_title_8002": "ICode地球级Python晋级赛",
        "week_game_already_go": "你已参加过本周晋级赛",
        "week_enter_txt_btn": "开始晋级赛",
        "week_warning_btn_start": "马上开始",
        "week_warning_btn_not_start": "暂不开始",
        "share_Phone_txt": "邀请人手机"
    }
}


// WEBPACK FOOTER //
// ./src/utils/i18n/zh.js